export default "__VITE_ASSET__DKw4MGHS__"